import { render } from "./vehicle.vue?vue&type=template&id=721c4fc0&scoped=true&ts=true"
import script from "./vehicle.vue?vue&type=script&lang=ts"
export * from "./vehicle.vue?vue&type=script&lang=ts"

import "./vehicle.vue?vue&type=style&index=0&id=721c4fc0&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721c4fc0"]])

export default __exports__